/**
 * @description 公共配置文件
 */

const BASE_URL = '/api';
const setting = {
    // 指定后端服务器IP和端口
    LoginUrl: BASE_URL + '/login',
    GetEquipmentByUserId: BASE_URL + '/getEquipmentByUserId',
    GetEquipmentByUserIdCP: BASE_URL + '/getEquipmentByUserIdCP',
    GetFactorByUserId: BASE_URL + '/getFactorByUserId',
    AddEquipment: BASE_URL + '/addEquipment',
    UpdateEquipment: BASE_URL + '/updateEquipment',
    GetAlarmPolicy: BASE_URL + '/getAlarmPolicy',
    UpdateAlarmPolicy: BASE_URL + '/updateAlarmPolicy',
    DeleteEquipment: BASE_URL + '/deleteEquipment',
    QueryUserByNameANDPwd: BASE_URL + '/queryUserByNameANDPwd',
    UpdateEquipmentUI: BASE_URL + '/updateEquipmentUI',
    GetHistoryCP: BASE_URL + '/getHistoryCP',
    GetHistoryByDateCP: BASE_URL + '/getHistoryByDateCP',
    GetHistoryByDate: BASE_URL + '/getHistoryByDate',
    GetHourHistoryByDateCP: BASE_URL + '/getHourHistoryByDateCP',
    GetHourHistoryByDate: BASE_URL + '/getHourHistoryByDate',
    GetMinutesHistoryByDateCP: BASE_URL + '/getMinutesHistoryByDateCP',
    GetMinutesHistoryByDate: BASE_URL + '/getMinutesHistoryByDate',
    GetHistoryByDate_Charts_API: BASE_URL + '/getHistoryByDate_Charts_API',
    GetBJDataCP: BASE_URL + '/getBJDataCP',
    GetBJDataByDateCP: BASE_URL + '/getBJDataByDateCP',
    GetRZDataCP: BASE_URL + '/getRZDataCP',
    GetRZDataByDateCP: BASE_URL + '/getRZDataByDateCP',
    GetWarningDataCP: BASE_URL + '/getWarningDataCP',
    GetWarningDataByDateCP: BASE_URL + '/getWarningDataByDateCP',
    GetMsgDataCP: BASE_URL + '/getMsgDataCP',
    GetMsgDataByDateCP: BASE_URL + '/getMsgDataByDateCP',
    GetCSDataCP: BASE_URL + '/getCSDataCP',
    GetCSDataCPByDate: BASE_URL + '/getCSDataCPByDate',
    UpdatePwd: BASE_URL + '/updatePwd',
    AddFactor: BASE_URL + '/addFactor',
    EditFactor: BASE_URL + '/editFactor',
    DeleteFactor: BASE_URL + '/deleteFactor',
    UpdateUI: BASE_URL + '/updateUI',
    GetAllUserByUserId: BASE_URL + '/getAllUserByUserId',
    AddUserByUserId: BASE_URL + '/addUserByUserId',
    UpdateUserEquipmentByUid: BASE_URL + '/updateUserEquipmentByUid',
    DeleteUser: BASE_URL + '/deleteUser',
    FindOnlyEquipmentByMN: BASE_URL + '/FindOnlyEquipmentByMN',
    FindEquipmentByMN: BASE_URL + '/FindEquipmentByMN',
    GetWarningUpToDate: BASE_URL + '/getWarningUpToDate',
    GetWarningByData: BASE_URL + '/getWarningByData',
    AddVido: BASE_URL + '/addVido',
    GetVidoByUserId: BASE_URL + '/getVidoByUserId',
    GetVidoByUserIdANDMN: BASE_URL + '/GetVidoByUserIdANDMN',
    UpdateVido: BASE_URL + '/updateVido',
    DeleteVido: BASE_URL + '/deleteVido',
    GetReportDate: BASE_URL + '/GetReportDate',
    FindEquipmentByAddress: BASE_URL + '/FindEquipmentByAddress',
    FindEquipmentByAddressCP: BASE_URL + '/FindEquipmentByAddressCP',
    FindEquipmentByAddressAndRegion: BASE_URL + '/FindEquipmentByAddressAndRegion',
    FindEquipmentByAddressAndRegionCP: BASE_URL + '/FindEquipmentByAddressAndRegionCP',
    FindEquipmentByRegionCP: BASE_URL + '/FindEquipmentByRegionCP',
    FindYunWeiSite:BASE_URL + '/FindYunWeiSite',
    AddYunWeiSite:BASE_URL + '/AddYunWeiSite',
    DeleteYunWeiSite:BASE_URL + '/DeleteYunWeiSite',
    DeleteAllYunWeiSite:BASE_URL + '/DeleteAllYunWeiSite',

    //获取日报表数据
    GetReportData_Day: BASE_URL + '/getReportData_Day',
    //马桥协议API
    //获取历史数据
}
export default setting  